import { modalFactory } from 'shared/lib/modalFactory';
import { IConfirmModalProps } from '../types';

export const modal = modalFactory<IConfirmModalProps>({
  isOpen: false,
  params: { title: 'Modal title', text: null, onConfirm: null },
});
